import { render } from "./view-proposal.vue?vue&type=template&id=127de52a"
import script from "./view-proposal.vue?vue&type=script&lang=js"
export * from "./view-proposal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__